export const pagesContractEn = {
  add: {
    intro: {
      body: {
        fillOutDetails: 'Fill out details',
        itemCard: {
          amount: 'Amount',
          contractTerm: 'Contract term',
          contractTitle: 'Contract title',
          employee: 'Employee',
          requiredDetails: 'Required details:',
          salary: 'Salary',
          title: {
            contractor_vendor: 'Contractor & Vendor',
            employment: 'Employment',
            lease_asset: 'Lease Asset',
            purchase: 'Purchase',
            software: 'Software',
            subscription: 'Subscription'
          },
          vendor: 'Vendor'
        },
        selectContractType: 'Select the Contract Type:'
      },
      header: {
        description: '',
        headerTitle: 'Add contract data to your registry'
      },
      options: {
        bulkCsvUpload: {
          button: 'Prepare csv file',
          description: 'You can add data for multiple contracts, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
          selectedContractType: 'Contract type:',
          selectedContractTypeTitle: {
            all: 'All Contracts',
            contractor_vendor: 'Contractor & Vendor',
            employment: 'Employment',
            lease_asset: 'Lease Asset',
            purchase: 'Purchase',
            software: 'Software',
            subscription: 'Subscription'
          },
          subscriptionCsvImportOrderHint: 'Import CSV files in this order: ① Contract → ② Tenant → ③ Plan.',
          subscriptionPhaseButton: {
            contract: 'Prepare contract CSV',
            plan: 'Prepare plan CSV',
            tenant: 'Prepare tenant CSV'
          },
          title: 'Bulk add by uploading a csv file'
        },
        description: 'Or you might want to...',
        existingContracts: 'Select from existing contract templates',
        syncExternalSystem: 'Sync with external contract management systems'
      }
    },
    subscription: {
      common: {
        back: 'Back',
        count: '{{count}} items',
        next: 'Next',
        submit: 'Submit',
        switchLabels: {
          allowed: 'Can',
          applicable: 'Yes',
          available: 'Yes',
          no: 'No',
          notAllowed: 'Not',
          notApplicable: 'No',
          notRequired: 'No',
          required: 'Yes',
          unavailable: 'No',
          yes: 'Yes'
        },
        units: {
          days: 'days',
          daysBefore: 'days before',
          percent: '%',
          seats: 'seats',
          users: 'users'
        }
      },
      completed: {
        completedBy: 'Created by:',
        goToContract: 'Go to contract',
        message: 'The subscription contract has been registered.',
        result: 'Registration result'
      },
      nav: {
        confirm: 'Confirmation',
        contractInfo: 'Contract Info',
        tenantAndPlan: 'Tenant & Plan',
        title: 'Register Subscription Contract'
      },
      progress: {
        filled: 'filled',
        modeSetting: 'Mode Settings',
        mustItemOnly: 'Must item only',
        required: 'Required',
        ringAccessibleName: 'Progress ring',
        total: 'Total'
      },
      step1: {
        contractEndDate: 'Contract End Date',
        contractNo: 'Contract No.',
        contractPeriod: 'Contract period',
        contractStartDate: 'Contract Start Date',
        contractSummary: 'Contract Summary',
        contractTitle: 'Contract Title',
        description: 'Enter basic contract information.',
        sectionTitle: 'Contract Information',
        softwareLibraryId: 'Service / software name',
        title: 'Basic Information'
      },
      step2: {
        affiliateCoverage: 'SaaS Subscription Affiliate Coverage',
        apiUsageAllowance: 'SaaS Subscription API Usage Allowance',
        autoRenewal: 'SaaS Subscription Auto-renewal',
        backupDataResidualRetention: 'SaaS Subscription Backup Data Residual Retention',
        billingCurrency: 'SaaS Subscription Billing Currency',
        billingFrequency: 'SaaS Subscription Billing Frequency',
        billingTiming: 'SaaS Subscription Billing Timing',
        commitmentConsumptionMeasurement: 'SaaS Subscription Commitment Consumption Measurement',
        dataExportMethod: 'SaaS Subscription Data Export Method',
        definitionOfAuthorizedUsers: 'SaaS Subscription Definition of User / Authorized Users',
        deletionCertificateAvailability: 'SaaS Subscription Deletion Certificate Availability',
        deletionCertificateAvailabilityNotes: 'SaaS Subscription Deletion Certificate Availabilit Notes',
        deploymentModel: 'SaaS Subscription Deployment Model',
        description: 'Enter detailed contract terms.',
        discountType: 'SaaS Subscription Discount Type',
        earlyTerminationAllowed: 'SaaS Subscription Early Termination Allowed',
        fairUseClause: 'SaaS Subscription Fair Use Clause',
        fairUseClauseNotes: 'SaaS Subscription Fair Use Clause Notes',
        filledCount: '{{filled}}/{{total}} filled',
        hint: 'Fill in only the items you need. You can edit them later.',
        includedModulesFeatures: 'SaaS Subscription Included Modules / Features',
        invoiceDeliveryMethod: 'SaaS Subscription Invoice Delivery Method',
        latePaymentPenalty: 'SaaS Subscription Late Payment Penalty',
        licenseMetric: 'SaaS Subscription License Metric',
        licenseReconciliationRule: 'SaaS Subscription License Reconciliation Rule',
        minimumPurchaseCommitment: 'SaaS Subscription Minimum Purchase Commitment',
        minimumPurchaseCommitmentUnit: 'SaaS Subscription Minimum Purchase Commitment Unit',
        options: {
          billingCurrency: {
            CNY: 'Yuan',
            IDR: 'Rupiah',
            JPY: 'Yen',
            THB: 'Baht',
            USD: 'Dollar',
            VND: 'Dong'
          },
          billingFrequency: {
            ANNUAL: 'Annual',
            MONTHLY: 'Monthly',
            OTHER: 'Other',
            QUARTERLY: 'Quarterly'
          },
          billingTiming: {
            IN_ARREARS: 'In Arrears',
            PREPAID: 'Prepaid'
          },
          deploymentModel: {
            HYBRID: 'Hybrid',
            ON_PREMISE: 'On-prem',
            SaaS: 'SaaS'
          },
          discountType: {
            BUNDLE_DISCOUNT: 'Bundle Discount',
            CONTRACT_DISCOUNT: 'Contract Discount',
            CUSTOM: 'Custom',
            NONE: 'None',
            PROMOTIONAL: 'Promotional',
            VOLUME_DISCOUNT: 'Volume Discount'
          },
          invoiceDelivery: {
            E_INVOICE_SYSTEM: 'E-Invoice System',
            EMAIL: 'Email',
            OTHER: 'Other',
            VENDOR_PORTAL: 'Vendor Portal'
          },
          licenseMetric: {
            API_CALL: 'API Call',
            CONCURRENT_USER: 'Concurrent User',
            DEVICE: 'Device',
            FLAT_FEE: 'Flat Fee',
            MAU: 'MAU',
            NAMED_USER: 'Named User',
            OTHER: 'Other',
            STORAGE: 'Storage',
            TENANT: 'Tenant',
            TRANSACTION: 'Transaction'
          },
          minimumPurchaseUnit: {
            AMOUNT: 'Amount',
            API_CALLS: 'API Calls',
            INSTANCES: 'Instances',
            LICENSES: 'Licenses',
            OTHER: 'Other',
            STORAGE: 'Storage',
            TENANT: 'Tenant',
            USERS: 'Users'
          },
          overageHandling: {
            AUTO_BILL: 'Auto Bill',
            GRACE_PERIOD: 'Grace Period',
            HARD_LIMIT: 'Hard Limit',
            NOTIFY_THEN_LIMIT: 'Notify Then Limit',
            OTHER: 'Other',
            SUSPEND: 'Suspend',
            THROTTLE: 'Throttle'
          },
          paymentDue: {
            CUSTOM: 'Custom',
            DUE_ON_RECEIPT: 'Due on Receipt',
            NET_15: 'Net 15',
            NET_30: 'Net 30',
            NET_45: 'Net 45',
            NET_60: 'Net 60'
          },
          paymentMethod: {
            ACH: 'ACH',
            BANK_TRANSFER: 'Bank Transfer',
            CHECK: 'Check',
            CREDIT_CARD: 'Credit Card',
            OTHER: 'Other',
            WIRE: 'Wire Transfer'
          },
          sourceOfTruth: {
            API_REPORT: 'API Report',
            BILLING_EXPORT: 'Billing Export',
            CONTRACT_ORDER_FORM: 'Contract / Order Form',
            OTHER: 'Other',
            THIRD_PARTY_MONITORING: 'Third Party Monitoring',
            VENDOR_ADMIN_CONSOLE: 'Vendor Admin Console',
            VENDOR_INVOICE: 'Vendor Invoice'
          },
          storageLimitUnit: {
            GB: 'GB',
            TB: 'TB'
          },
          taxCategory: {
            CUSTOM: 'Custom',
            EXEMPT: 'Exempt',
            MIXED: 'Mixed',
            OUT_OF_SCOPE: 'Out of Scope',
            REVERSE_CHARGE: 'Reverse Charge',
            TAXABLE: 'Taxable',
            ZERO_RATED: 'Zero Rated'
          },
          trueUpTiming: {
            ANNUAL: 'Annual',
            AT_CONTRACT_END: 'At Contract End',
            AT_RENEWAL: 'At Renewal',
            MONTHLY: 'Monthly',
            QUARTERLY: 'Quarterly',
            UNKNOWN: 'Unknown'
          }
        },
        overageHandling: 'SaaS Subscription Overage Handling',
        overageHandlingNotes: 'SaaS Subscription Overage Handling Notes',
        paymentDue: 'SaaS Subscription Payment Due',
        paymentMethod: 'SaaS Subscription Payment Method',
        poRequired: 'SaaS Subscription PO Required',
        postTerminationDataRetention: 'SaaS Subscription Post-termination Data Retention',
        priceChangeClause: 'SaaS Subscription Price Change Clause',
        priceLockProtection: 'SaaS Subscription Price Lock / Protection',
        reassignmentRestriction: 'SaaS Subscription Reassignment Restriction',
        recommendedRenewalNegotiationStart: 'SaaS Subscription Recommended Renewal Negotiation Start',
        refundPolicy: 'SaaS Subscription Refund Policy',
        renewalConditions: 'SaaS Subscription Renewal Conditions (Price/Quantity)',
        renewalQuoteValidity: 'SaaS Subscription Renewal Quote Validity',
        sections: {
          billing: 'Billing&Payment',
          dataRetention: 'Offboarding (Event)',
          license: 'Entitlement & Usage',
          renewal: 'Renewal (Event)',
          softwareDetail: 'Product & Delivery'
        },
        sourceOfTruthForUsage: 'SaaS Subscription Source of Truth for Usage',
        storageLimit: 'SaaS Subscription Storage Limit',
        storageLimitNotes: 'SaaS Subscription Storage Limit Notes',
        storageLimitUnit: 'Storage Limit Unit',
        suspensionTriggers: 'SaaS Subscription Suspension Triggers',
        taxCategory: 'SaaS Subscription Tax Category',
        taxRate: 'SaaS Subscription Tax Rate',
        terminationMethod: 'SaaS Subscription Termination / Non-renewal Method',
        terminationNoticePeriod: 'SaaS Subscription Termination / Non-renewal Notice Period',
        title: 'Contract Detail',
        trueUpTiming: 'SaaS Subscription True-up Timing',
        trueUpTrueDownApplicable: 'SaaS Subscription True-up / True-down Applicable',
        vendorRightToChangeServiceAtRenewal: 'SaaS Subscription Vendor Right to Change Service at Renewal'
      },
      step3: {
        addTenant: '+ Add Tenant',
        countryCodes: 'SaaS Subscription Service Region / Data Residency',
        description: 'Select the target software and tenants for this contract. You can also proceed without selecting any.',
        environments: 'SaaS Subscription Environments',
        federationAuthMethods: 'SaaS Subscription Federation / Auth Method',
        noSoftware: 'No software is registered.',
        options: {
          environment: {
            DEV: 'Dev',
            OTHER: 'Other',
            PRODUCTION: 'Production',
            SANDBOX: 'Sandbox',
            STAGING: 'Staging',
            TEST: 'Test'
          },
          federationAuth: {
            OAUTH: 'OAuth',
            OIDC: 'OIDC',
            OTHER: 'Other',
            PASSWORD_LOGIN: 'Password Login',
            SAML: 'SAML'
          }
        },
        removeTenant: 'Remove',
        serviceRegionDataResidencyNotes: 'SaaS Subscription Service Region / Data Residency Notes',
        softwareName: 'Software',
        softwarePlaceholder: 'Select software',
        tenantId: 'SaaS Subscription Tenant ID',
        tenantLabel: 'Tenant {{index}}',
        tenantName: 'Tenant',
        title: 'Tenants',
        useCustomSaas: 'Select from custom SaaS software'
      },
      step4: {
        addPlan: '+ Add Plan',
        baseSeatsUsersPurchased: 'SaaS Subscription Base Seats / Users Purchased',
        concurrentUsersLimit: 'SaaS Subscription Concurrent Users Limit',
        description: 'Define plans independently of tenants. You can assign plans to tenants in the next step.',
        extendedLogRetentionOption: 'SaaS Subscription Extended Log Retention Option',
        freeTierTrialApplicable: 'SaaS Subscription Free Tier / Trial Applicable',
        freeTierTrialTerms: 'SaaS Subscription Free Tier / Trial Terms',
        noTenants: 'Select at least one tenant to enter details.',
        notEntered: 'Not entered',
        options: {
          currency: {
            CNY: 'Yuan',
            IDR: 'Rupiah',
            JPY: 'Yen',
            THB: 'Baht',
            USD: 'Dollar',
            VND: 'Dong'
          },
          pricingModel: {
            BUNDLE: 'Bundle',
            FLAT_FEE: 'Flat fee',
            HYBRID: 'Hybrid',
            OTHER: 'Other',
            PACKAGE: 'Package',
            TIERED: 'Tiered',
            USAGE_BASED: 'Usage-based'
          },
          unitPricePeriod: {
            CUSTOM: 'Custom',
            MONTH: 'Month',
            ONE_TIME: 'One-Time',
            PER_USAGE: 'Per Usage',
            QUARTER: 'Quarter',
            YEAR: 'Year'
          },
          unitPriceUnit: {
            AMOUNT: 'Amount',
            API_CALLS: 'API Calls',
            INSTANCES: 'Instances',
            LICENSES: 'Licenses',
            OTHER: 'Other',
            STORAGE: 'Storage',
            TENANT: 'Tenant',
            USERS: 'Users'
          }
        },
        planLabel: 'Plan {{index}}: {{name}}',
        planName: 'SaaS Subscription Plan / Edition',
        pricingModel: 'SaaS Subscription Pricing Model',
        removePlan: 'Remove',
        standardLogRetention: 'SaaS Subscription Standard Log Retention',
        standardLogRetentionNotes: 'SaaS Subscription Standard Log Retention Notes',
        title: 'Plan Definition',
        unitPriceCurrency: 'Unit Price Currency',
        unitPriceNumber: 'Unit Price',
        unitPricePeriod: 'Unit Price Period',
        unitPriceSection: 'Unit Price Settings',
        unitPriceUnit: 'Unit Price Unit'
      },
      step5: {
        assign: 'Assign Plan',
        cancelCustomPrice: 'Stop custom pricing',
        customPriceTitle: 'Custom unit price',
        customizePrice: 'Set custom unit price',
        description: 'Check the plan(s) to apply to each tenant and set the seat count and unit price individually. If tenants are selected, at least one plan must be assigned per tenant.',
        lineAmount: 'Amount',
        noPlans: 'No plans have been defined in STEP4. Please go back and add a plan.',
        noTenants: 'Select at least one tenant to enter details.',
        overrideMemo: 'Override reason memo',
        planName: 'Plan',
        seats: 'Seats',
        selectionRequired: 'Every tenant must have at least one plan assigned.',
        tenantName: 'Tenant',
        title: 'Tenant / Plan Assignment',
        unassign: 'Unassign',
        unitPriceCurrency: 'Currency',
        unitPriceNumber: 'Unit Price',
        unitPricePeriod: 'Period',
        unitPriceUnit: 'Price Unit',
        unknownTenant: 'Unknown tenant'
      },
      step6: {
        assignmentNotSet: 'No assignment data to display. Return to the plan definition step, fix any issues, and click Next to regenerate assignments.',
        billingCurrencyLabel: 'SaaS Subscription Billing Currency: {{value}}',
        billingFrequencyLabel: 'SaaS Subscription Billing Frequency: {{value}}',
        columns: {
          amount: 'Amount',
          freeTierTrial: 'Free tier / trial terms',
          planName: 'Plan name',
          pricingModel: 'Pricing model',
          quantity: 'Quantity',
          softwareName: 'Software name',
          tenantName: 'Tenant name',
          unitPrice: 'Unit price',
          unitPriceSettings: 'Unit price settings'
        },
        customSaas: 'Custom SaaS',
        customUnitPrice: 'Custom unit price',
        deploymentLabel: 'SaaS Subscription Deployment Model: {{value}}',
        description: 'Review your input and submit.',
        filledCount: '{{count}} items filled',
        licenseMetricLabel: 'SaaS Subscription License Metric: {{value}}',
        notEntered: '(Not entered)',
        notSelected: 'Not selected',
        sections: {
          assignments: 'Assignments ({{count}} items)',
          contract: 'Contract',
          contractDetail: 'Contract Detail',
          plans: 'Plans ({{count}} items)',
          software: 'Software',
          tenants: 'Tenants ({{count}} items)'
        },
        softwareDisplayFallback: 'Software information unavailable.',
        softwareLoadError: 'Could not load software details.',
        softwareLoading: 'Loading software…',
        standardUnitPrice: 'Standard unit price',
        submitButton: 'Register Contract',
        title: 'Confirm & Register',
        titleNotEntered: 'Title not entered',
        undecided: 'Undecided'
      },
      toast: {
        createError: 'Failed to create subscription contract.',
        createSuccess: 'Subscription contract created successfully.',
        error: 'Error',
        success: 'Success',
        validationError: 'Validation Error',
        validationErrorDescription: 'Please check your input.'
      }
    }
  },
  comingSoon: {
    alerts: {
      description: 'Contract alerts and notifications are coming soon.',
      title: 'Contract Alerts'
    },
    contractAndCost: {
      description: 'Contract and cost management is coming soon.',
      title: 'Contract & Cost'
    },
    defaultDescription: 'This page is coming soon. Please check back later.',
    operationActivity: {
      description: 'Contract operation activity tracking is coming soon.',
      title: 'Operation Activity'
    },
    overview: {
      description: 'Contract overview dashboard is coming soon.',
      title: 'Contract Overview'
    },
    people: {
      description: 'Contract people management is coming soon.',
      title: 'Contract People'
    }
  },
  detail: {
    body: {
      errors: {
        contractIdLabel: 'Contract ID: {{id}}',
        contractNotFound: 'Contract details not found',
        dataLoadFailed: 'Failed to load data',
        unknownError: 'An unknown error occurred'
      },
      groups: {
        commonInformation: 'Common Information',
        employmentContract: 'Employment Contract',
        leaseContract: 'Lease Contract',
        purchaseContract: 'Purchase Contract',
        serviceContract: 'Service Contract',
        subscriptionContract: 'Subscription Contract'
      },
      noDataMessage: 'No data available in this section.',
      sections: {
        benefitsInternalPolicies: 'Benefits & Internal Policies',
        compensation: 'Compensation',
        contractIdInfo: 'Contract ID Information',
        contractTerms: 'Contract Terms',
        employmentTerms: 'Employment Terms & Contract',
        workingTimeShifts: 'Working Time & Shifts',
        worksiteMaster: 'Worksite Master'
      }
    },
    header: {
      dataLoadFailed: 'Failed to load contract header data',
      noRenewalDate: 'No Renewal Date',
      renewalDate: 'Renewal Date',
      status: 'Status'
    },
    subscription: {
      editBottomSheet: {
        sections: {
          assignments: {
            description: 'Assign plans to tenants. Configure seats and override unit prices per tenant if needed.',
            title: 'Tenant / Plan assignment'
          },
          plans: {
            description: 'Define plans independently of tenants. The unit price configured here is used as the default for assignment.',
            title: 'Plans'
          },
          tenants: {
            description: 'Select tenants linked to this contract from the Software master.',
            title: 'Tenants'
          }
        },
        tenants: {
          currentTenantsTitle: 'Current tenants',
          unnamedTenant: '(no name)'
        },
        title: 'Edit tenants, plans and assignments',
        toast: {
          saveSuccess: 'Tenant / plan information saved.',
          validationError: 'Validation error',
          validationErrorDescription: 'Please review your inputs.'
        }
      },
      matrix: {
        appliedFrom: 'Applied from: {{value}}',
        cornerLabel: 'Tenant \\ Plan',
        customPriceLabel: 'Custom unit price',
        emptyCell: '—',
        individualSettingBadge: 'Individual setting',
        noData: 'No assignment data available.',
        subtotalColumn: 'Subtotal (monthly)',
        totalRow: 'Total (monthly)',
        unknownTenant: 'Unknown tenant'
      },
      tenantInformation: {
        subtitle: 'Environments used under this contract and linked Software instances by corporation',
        title: 'Tenant information'
      }
    },
    tabs: {
      approvalInfo: 'Approval Info',
      detail: 'Detail',
      history: 'History',
      operationActivity: 'Operation Activity',
      riskProvisions: 'Risk Provisions',
      rulesPolicy: 'Rules & Policy',
      structure: 'Structure'
    }
  },
  importCsv: {
    checkValidColumn: {
      errors: 'errors',
      warnings: 'warnings'
    },
    completeDialog: {
      button: 'Done'
    },
    contractType: {
      filename: {
        all: 'AllContracts',
        contractorVendor: 'ContractorVendor',
        employment: 'Employment',
        leaseAsset: 'LeaseAsset',
        purchase: 'Purchase',
        software: 'Software',
        subscription: 'Subscription',
        subscriptionContract: 'Subscription_Contract',
        subscriptionPlan: 'Subscription_Plan',
        subscriptionTenant: 'Subscription_Tenant'
      },
      prepareCsvFile: {
        templateTitle: {
          all: 'New contracts',
          contractorVendor: 'New contractor & vendor contracts',
          employment: 'New employment contracts',
          leaseAsset: 'New lease asset contracts',
          purchase: 'New purchase contracts',
          software: 'New software contracts',
          subscription: 'New subscription contracts',
          subscriptionContract: 'New contract (contract)',
          subscriptionPlan: 'New contract (plan)',
          subscriptionTenant: 'New contract (tenant)'
        },
        updateExisting: {
          all: 'Update existing contracts',
          contractorVendor: 'Update existing contractor & vendor contracts',
          employment: 'Update existing employment contracts',
          leaseAsset: 'Update existing lease asset contracts',
          purchase: 'Update existing purchase contracts',
          software: 'Update existing software contracts',
          subscription: 'Update existing subscription contracts',
          subscriptionContract: 'Update existing contract (contract)',
          subscriptionPlan: 'Update existing contract (plan)',
          subscriptionTenant: 'Update existing contract (tenant)'
        }
      },
      title: {
        all: 'All Contracts Bulk Import',
        contractorVendor: 'Contractor & Vendor Contract Bulk Import',
        employment: 'Employment Contract Bulk Import',
        leaseAsset: 'Lease Asset Bulk Import',
        purchase: 'Purchase Contract Bulk Import',
        software: 'Software Contract Bulk Import',
        subscription: 'Subscription Contract Bulk Import'
      },
      unit: {
        contractorVendors: 'contractor & vendor contracts',
        contracts: 'contracts',
        employments: 'employment contracts',
        leaseAssets: 'lease asset contracts',
        purchaseContracts: 'purchase contracts',
        software: 'software contracts',
        subscriptionContracts: 'subscription contracts'
      }
    },
    subscriptionPhases: {
      contract: 'Contract',
      plan: 'Plan',
      tenant: 'Tenant'
    },
    /** サブスク3分割: 契約 / テナント / CSV */
    table: {
      columns: {
        amount: 'Amount',
        contractEndDate: 'Contract End Date',
        contractStartDate: 'Contract Start Date',
        contractTitle: 'Contract Title',
        vendor: 'Vendor'
      }
    }
  },
  overview: {
    activity: {
      emptyLabel: 'No recent activity.',
      title: 'Recent Activity',
      untitledContract: '(Untitled contract)'
    },
    contractCategoryBreakdown: {
      title: 'Contract Category'
    },
    contractTypeBreakdown: {
      title: 'Contract Type'
    },
    endedOrCancelled: {
      title: 'Ended / Cancelled'
    },
    executed: {
      title: 'Executed'
    },
    inProgress: {
      title: 'In Progress'
    },
    schedule: {
      emptyLabel: 'No expirations scheduled this month or next.',
      title: 'Expiry Schedule'
    },
    total: {
      title: 'Contracts'
    },
    unit: {
      cases: 'cases',
      types: 'types'
    }
  },
  title: 'Contracts'
};